export default __webpack_public_path__ + "static/media/olga.f47b2778.png";